import gql from 'graphql-tag'

export const mutation = gql`
  mutation insertRole($fields: roles_insert_input!) {
    record: insert_roles_one(object: $fields) {
      id
    }
  }
`

export default mutation
